import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/AuthSlice';
import appReducer from './reducers/AppSlice';
import langReducer from './reducers/LangSlice';
import modalReducer from './reducers/ModalSlice';
import userInfoReducer from './reducers/UserInfoSlice';
import { brizUaAPI } from '../services/apiServices/brizUa';
import { userApi } from '../services/apiServices/user';

const rootReducer = combineReducers({
  authReducer,
  appReducer,
  langReducer,
  modalReducer,
  userInfoReducer,
  [brizUaAPI.reducerPath]: brizUaAPI.reducer,
  [userApi.reducerPath]: userApi.reducer,
});

export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(brizUaAPI.middleware, userApi.middleware),
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
